import React from "react";
import CustomCheckbox from "@/src/lib/ui/customCheckbox";

const SpecializationListFilter = ({
    item,
    handleChangeSpecialization,
    selectedValues,
}) => {
    const checked = Array.isArray(selectedValues)
        ? selectedValues.includes(item.specializationId)
        : false;

    return (
        <div className="flex items-center gap-4 mb-4">
            <CustomCheckbox
                checked={checked}
                onChange={(e) =>
                    handleChangeSpecialization(
                        item.specializationId,
                        e.target.checked
                    )
                }
                label={item.specializationName}
            ></CustomCheckbox>
        </div>
    );
};

export default React.memo(SpecializationListFilter);
